import './style.scss';
import './wix.scss';
import Dropdown from './dropdown.js';

export default Dropdown;